
















































import { Component, Vue, Prop } from 'vue-property-decorator';

import { Products } from '@/models/Products';

@Component({
    name: 'CarouselProducts',
})
export default class CarouselProducts extends Vue {
    @Prop(Array) private products: Products;

    private addProductToCar(product: Products): void {
        this.$emit('on-add-product-to-car', product);
    }
}
